interface IParseDeployedAppBuildIdProps {
  body: string;
}

// NOTE: NSAI-8170 — read as text, not `response.json()`: an image built before
// the version file existed has none, and the edge proxy answers that miss with
// the SPA's index.html under a 200. Anything that is not `{ buildId: "…" }`
// therefore means "unknown", never "a newer build".
export const parseDeployedAppBuildId = ({
  body,
}: IParseDeployedAppBuildIdProps): string | null => {
  let payload: unknown;

  try {
    payload = JSON.parse(body);
  } catch {
    return null;
  }

  if (typeof payload !== "object" || payload === null) {
    return null;
  }

  if (!("buildId" in payload)) {
    return null;
  }

  const { buildId } = payload;

  return typeof buildId === "string" && buildId.length > 0 ? buildId : null;
};
